import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { CURRENT_DATE_FORMAT, MAINTENANCE_DATE_FORMAT } from '~/constants'

dayjs.extend(isBetween)

export function useMaintenanceSite() {
  const MAINTENANCE = 'maintenance'
  const { layout } = useResponsiveComponent()
  const maintenanceTime = useRuntimeConfig().public.MAINTENANCE_TIME
  const [startTime, startDate, endTime, endDate] = maintenanceTime.split(' - ')

  // Ensure currentDate is only set on the client
  const currentDate = ref(dayjs().format(MAINTENANCE_DATE_FORMAT))
  
  const startMaintenanceTime = dayjs(
    `${startDate} ${startTime}`,
    CURRENT_DATE_FORMAT,
  ).format(MAINTENANCE_DATE_FORMAT)

  const endMaintenanceTime = dayjs(
    `${endDate} ${endTime}`,
    CURRENT_DATE_FORMAT,
  ).format(MAINTENANCE_DATE_FORMAT)

  const hasMaintenance = computed(() => {
    if (!currentDate.value) {
      return false
    } // Prevents hydration issues
    return dayjs(currentDate.value).isBetween(
      startMaintenanceTime,
      endMaintenanceTime,
    )
  })

  const displayedLayout = computed(() => {
    if (hasMaintenance.value) {
      return MAINTENANCE
    }
    return layout
  })

  return {
    displayedLayout,
    hasMaintenance,
  }
}
